import { createSlice } from "@reduxjs/toolkit"

export interface LoadingState {
  open: boolean
}

export const initialState: LoadingState = Object.freeze({
  open: false,
})

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setOpen(state) {
      state.open = true
    },
    setClose(state) {
      state.open = false
    },
  },
})

export const loadingActions = loadingSlice.actions

export default loadingSlice.reducer
